import { FeatureConfig } from '@typesApp/Config'
import { baseConfig_CAFlow } from './baseConfig_CAFlow'
import { baseConfig_USFlow } from './baseConfig_USFlow'
import { baseConfig_VDFlow } from './baseConfig_VDFlow'

/**
 * Brand specific feature configuration. Each brand inherits
 * the base CA, US, or VD flow configuration and may include
 * brand specific values.
 */
const BrandFeatureConfig: Record<string, FeatureConfig> = {
  'oak-us': {
    ...baseConfig_USFlow,
  },
  'lcr-us': {
    ...baseConfig_USFlow,
  },
  'ebd-us': {
    ...baseConfig_USFlow,
    disableScheduleEyeExamLink: true,
    contactUs: ['phone', 'faq'],

    // no EyeMed plus logo
    overviewWidgetOptions: {
      insurerLogos: ['EyeMed', 'Aetna', 'Humana', 'Cigna'],
    },
  },
  'fde-us': {
    ...baseConfig_USFlow,
    disableDistributeBenefits: true,
    // refreshCart triggers full page reload on FDE so we call it only on cart page
    enableRefreshCartGuardOnApplyInsurance: true,
    contactUs: ['phone', 'faq'],
  },
  'nua-us': {
    ...baseConfig_USFlow,
    disableInsuranceToggleMessages: true,
  },
  'cle-ca': {
    ...baseConfig_CAFlow,
    contactUs: ['phone', 'email', 'chat'],
  },
  'oak-ca': {
    ...baseConfig_CAFlow,
  },
  'lcr-ca': {
    ...baseConfig_CAFlow,
    clickableTooltip: true,
    disableValidateRxAnimation: true,
    rxhelpGuideOptions: {
      hideContacts: true,
      glassesrx: {
        enableWhatSection: false,
        enablePrismSection: true,
      },
    },
  },
  'vde-fr': {
    ...baseConfig_VDFlow,
  },
  'gdo-fr': {
    ...baseConfig_VDFlow,
  },
  'gop-fr': {
    ...baseConfig_VDFlow,
  },
}

type EnvType = 'DEV' | 'TEST' | 'STAGE' | 'PROD'
type BrandConfig = Record<string, FeatureConfig>

const EnvBrandFeatureConfig: Record<string, BrandConfig> = {
  TEST: {
    'cle-ca': {
      ...BrandFeatureConfig['cle-ca'],
      disableAuthTokenForGuest: false,
    },
  },
  STAGE: {
    'vde-fr': {
      ...BrandFeatureConfig['vde-fr'],
      disableStrictSSNValidation: true,
    },
  },
}

export const featureConfig: Record<EnvType, BrandConfig> = {
  DEV: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['DEV'],
  },
  TEST: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['TEST'],
  },
  STAGE: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['STAGE'],
  },
  PROD: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['PROD'],
  },
} as const
